import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('Workspaces');

export const organisationWorkspacesQueries = {
  selectAll: baseQuery
};
